export default __webpack_public_path__ + "static/media/a4.83e0ebc3.webp";